import React from 'react';
import { connect } from 'react-redux';
import { Alert } from 'reactstrap';
import SortIcons from './ProposalsSortIcons';
import Routing from './Routing';

const RoutingList = ({ e911, gateways, selectRoute, handleQuery, queryLrn, sortValue, onSort, isReadOnly }) => {
  return (
    <div className="table-header-fixed">
      <table className="provisionList">
        <thead>
          <tr>
            <th className="cursor-pointer" onClick={() => e911.length > 0 && onSort('number')}>
              Number <SortIcons sortObj={sortValue} sortName="number" />
            </th>
            <th
              className="cursor-pointer"
              onClick={() => e911.length > 0 && onSort('company[name]')}
            >
              Company <SortIcons sortObj={sortValue} sortName="company[name]" />
            </th>
            <th
              className="cursor-pointer"
              onClick={() => e911.length > 0 && onSort('assignedTo[email]')}
            >
              User <SortIcons sortObj={sortValue} sortName="assignedTo[email]" />
            </th>
            <th onClick={() => e911.length > 0 && onSort('type')}>
              Type <SortIcons sortObj={sortValue} sortName="type" />
            </th>
            <th>Route</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {e911.length ? (
            e911.map((item, idx) => (
              <Routing
                handleQuery={handleQuery}
                queryLrn={queryLrn}
                selectRoute={selectRoute}
                key={idx}
                e911={item}
                gateways={gateways}
                isReadOnly={isReadOnly}
              />
            ))
          ) : (
            <tr>
              <td colSpan={12}>
                <Alert rowSpan={12} color="info">
                  No Record Found
                </Alert>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

const mapStateToProps = state => ({
  user: state.AppState.user,
});

export default connect(mapStateToProps)(RoutingList);
